import { configureStore } from '@reduxjs/toolkit';
import fileReducer from './fileSlice';
import { msalInstance } from '../components/config/msalConfig';

export const store = configureStore({
  reducer: {
    files: fileReducer,
  },
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware({
      thunk: {
        extraArgument: {
          msalInstance,
        },
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type ThunkApiConfig = {
  rejectValue: string;
  extra: {
    msalInstance: typeof msalInstance;
  };
};